<template>
<div class="chapter">
<div class="inner_page">
<p class="P-P19"></p>
<p class="P-P20"><br/></p>
<p class="P-P21"> </p>
<p class="P-P22">For Honey, Uncle Buddy, and Aunt Charline</p>
<p class="P-P22"> </p>
<p class="P-P22">For Don and Dona</p>
<p class="P-P23"> </p>
<p class="P-P23">For my husband Dan and our children Briley and Adeline</p>
<p class="P-P24"><br/></p>
<p class="P-P24"><br/></p>
<p class="P-P24">www.carrienyman.com</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0002.vue?aed6fdf0